import type { ModalSize } from '~/components/Modal/Container/Container';
import Container, { MobileModal as MobileContainer } from '~/components/Modal/Container/Container';

export default Container;

export { ModalSize, MobileContainer };
